// Use this helper instead of product-helpers since theres no import dependencies that can break if imported into Fortive-B2B
// remove any non numeric chars from a string
// used for checking if a product price is 0. 
// $0.00 $0,00 etc.
export function isZeroValue(input: string | undefined | null) {
  if (!input) {
    return true;
  }
  const digitsOnly = input.replace(/\D/g, '');
  const value = Number(digitsOnly);
  return value === 0;
}

// format a number to a currency string
export function formatCurrencyAmount(
  value: number,
  currency = 'USD',
  locale = 'en-US',
): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(value.toFixed(2)));
}